<template>
    <el-dialog
        title="异常反馈"
        :visible.sync="errorFeedbackVisible"
        width="500px"
        :before-close="closeDialogOnly"
        class="errorFeedback"
    >
        <el-form
            :model="data"
            ref="errorFeedBackForm"
            :rules="rules"
            :label-width="formLabelWidth"
            v-loading="loading"
        >
            <el-form-item label="一级原因" prop="exceptionReason1Code">
                <el-select
                    v-if="rowData.orderType === 'DP'"
                    v-model="data.exceptionReason1Code"
                    placeholder="请选择"
                    class="exceptionType"
                >
                    <el-option value="GC08" label="取件异常" key="GC08"></el-option>
                </el-select>
                <el-select
                    v-else
                    v-model="data.exceptionReason1Code"
                    placeholder="请选择"
                    class="exceptionType"
                >
                    <el-option value="GC06" label="配送异常" key="GC06"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级原因" prop="exceptionReason2Code">
                <otp-select
                    v-if="rowData.orderType === 'DP'"
                    :optionNum="'NET_PICKUP_ERROR'"
                    v-model="data.exceptionReason2Code"
                    @getSelectLabel="value=>{data.exceptionReason2Name=value}"
                ></otp-select>
                <otp-select
                    v-else
                    :optionNum="'NET_DELIVERY_ERROR'"
                    v-model="data.exceptionReason2Code"
                    @getSelectLabel="value=>{data.exceptionReason2Name=value}"
                ></otp-select>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" placeholder="请输入内容" v-model="data.exceptionRemark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogOnly">取 消</el-button>
            <el-button type="primary" @click="saveFeedback">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import OtpSelect from '@/components/lots/otpSelect2/index';
import api from '../../../../api/netTaskManage2c';
export default {
    components: { OtpSelect },
    data() {
        return {
            loading: false,
            errorFeedbackVisible: false,
            rowData: {},
            data: {
                orderNo: '',
                exceptionReason1Code: '',
                exceptionReason1Name: '',
                exceptionReason2Code: '',
                exceptionReason2Name: '',
                exceptionRemark: ''
            },
            rules: {
                exceptionTypeCode: [
                    {
                        required: true,
                        message: '请选择异常类型',
                        trigger: 'change'
                    }
                ],
                exceptionReason1Code: [
                    {
                        required: true,
                        message: '请选择一级原因',
                        trigger: 'change'
                    }
                ],
                exceptionReason2Code: [
                    { required: true, message: '请选择二级原因', trigger: 'change' }
                ]
            },
            formLabelWidth: '80px'
        };
    },
    methods: {
        show(rowData) {
            this.errorFeedbackVisible = true;
            this.loading = true;
            this.rowData = rowData;
            if (this.$refs['errorFeedBackForm']) {
                this.$refs['errorFeedBackForm'].resetFields();
            }
            this.data.orderNo = rowData.orderNo;
            if (rowData.orderType === 'DP') {
                this.data.exceptionReason1Code = 'GC08';
                this.data.exceptionReason1Name = '取件异常';
            } else {
                this.data.exceptionReason1Code = 'GC06';
                this.data.exceptionReason1Name = '配送异常';
            }
            this.loading = false;
        },
        async saveFeedback() {
            let flag = false;
            await this.$refs.errorFeedBackForm.validate((value) => {
                flag = value;
            });
            if (flag) {
                this.loading = true;
                await api
                    .saveError(this.data)
                    .then((res) => {
                        if (res && res.code === '0') {
                            this.$message.success('异常提交成功');
                            this.closeAndRefresh();
                        }
                    })
                    .catch(() => {});
                this.loading = false;
            }
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'errorFeedbackDialog', false);
        },
        closeAndRefresh() {
            this.$emit('closeDialog', 'errorFeedbackDialog', true);
        }
    }
};
</script>

<style lang="less">
.errorFeedback {
    .exceptionType {
        width: 100%;
    }
}
</style>